"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_pfeil_west = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_pfeil_west = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACMSURBVFhH7ZTBDUBAEEXXzVEZjtpxU4ISdKIMRyUogaObEvhjdxI23NZgMy952R/J5v+9MIqi/JEapjbK08IVdlB8BJeTC8yhGH55AcXQ8rjLE3ceofLKxp3JGZIZljaeaSC//ElHeEkGB3h1KaS3Awh/BGX6JoqOYHQE87kR4r9mhkb08JVyRYkRYzbANWuHbKmjsgAAAABJRU5ErkJggg==",
    iconSize: [32, 32],
});
